// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__22hKl","productName":"Table_productName__2yk_J"};